"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateValleyBankLoanAccountWithCollateralStats = exports.getLoanAccountStats = exports.getLoanAccountCollateralStats = exports.getTotalLoanOutstanding = exports.getLoans = exports.orderLoanAccountsLoans = exports.findCommitmentsWithMissingParentCommit = exports._getValleyBankSubLoanAccountUniqueIdentifier = exports.isSubLoanAccountMasterCommitment = exports.getSubLoansTotalOutstandingBalance = exports.isContributesToOutstandingBalance = exports.getValleyBankSubLoanAccountOutstandingBalance = exports.generateLoanAccount = exports.isMasterCommitment = void 0;
/* eslint-disable camelcase */
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const collateralAccountUtils = __importStar(require("./collateralAccounts"));
const generateReceivableStats_1 = require("./generateReceivableStats");
const utils_1 = require("./utils");
const vanCmmtTypeMap = {
    ACC: 'Acceptances',
    ACH: 'ACH Line',
    ARV: 'ABL Revolver',
    ATL: 'ABL Term LN',
    CON: 'Construction',
    CVL: 'Cash Value LOC',
    EZL: 'EZ-Line',
    FX: 'Foreign Exchange',
    FXF: 'FX Forward',
    HEL: 'HELOC',
    LC: 'Letter of Credit ',
    LIP: 'Resi Construction',
    MAS: 'Master Commitment',
    NPR: 'Non Purpose Revolver',
    ODP: 'Overdraft',
    ONC: 'OneCard',
    OVD: 'Overdraft',
    PLC: 'Personal LOC',
    PRT: 'Participation',
    REV: 'Revolver',
    RSK: 'Risk Participation',
    SB: 'Standby Letter of Credit',
    SBA: 'SBA PPP',
    SWP: 'Swap Exposure',
    TL: 'NonRevolving Term LN',
};
const _findUltimateCommitment = ({ commitmentId, commitments, }) => {
    if (!commitmentId)
        return null;
    const commitment = commitments.find((currCommitment) => currCommitment.commitmentId === commitmentId);
    if (!commitment)
        return null;
    return commitment.ultimateCommitmentId;
};
const isMasterCommitment = (cmmt) => cmmt.commitment_num === cmmt.ultim_commitment_num;
exports.isMasterCommitment = isMasterCommitment;
const generateLoanAccount = ({ loanAccountNumber, reportingDate, asOfDate, vanCmmt, vanLoanAcct, cuoLoan, arrangementGroupId, loanParties, derivativePath, }) => {
    if (!vanCmmt.length && !vanLoanAcct.length && !derivativePath.length) {
        return null;
    }
    // accountName and cifNum can be scattered across records, we'll just use the first one we find
    // if we find one
    let accountName = null;
    let cifNum = null;
    if (vanCmmt.length) {
        cifNum = vanCmmt[0].cif_num;
    }
    else if (vanLoanAcct.length) {
        cifNum = vanLoanAcct[0].cif_num;
    }
    else if (derivativePath.length) {
        cifNum = derivativePath[0].cif_num;
    }
    (0, common_1.finleyAssert)(cifNum, `unable to resolve cifNum for [loanAccountNumber:${loanAccountNumber}]`);
    let principalBalance = 0;
    const commitments = [];
    vanCmmt.sort((a, b) => Number(a.commitment_num) - Number(b.commitment_num));
    vanCmmt.forEach((cmmt) => {
        if (!accountName && cmmt.account_name) {
            accountName = cmmt.account_name;
        }
        let isMaster = false;
        if ((0, exports.isMasterCommitment)(cmmt)) {
            principalBalance += cmmt.used_amt;
            isMaster = true;
        }
        commitments.push({
            type: 'commitment',
            accountNumber: cmmt.account_num,
            commitmentId: cmmt.commitment_id,
            noteId: null,
            productDescription: isMaster
                ? 'Master Commitment'
                : `Subcommitment - ${vanCmmtTypeMap[cmmt.type] ?? cmmt.type}`,
            loanAmount: cmmt.current_amt,
            noteDate: cmmt.renewal_date,
            maturityDate: cmmt.expire_date,
            interestRate: null,
            currency: null,
            fxAmount: null,
            fxRate: null,
            currentBalance: cmmt.used_amt,
            source: 'IBS',
            contributesToPrincipalBalance: isMaster,
            ultimateCommitmentId: `${cmmt.account_num}${cmmt.ultim_commitment_num}`,
            valuationDate: null,
            usdCurrentNotionalAmount: null,
            initialMarginRequirementAmount: null,
            initialMarginRequirementRate: null,
            markToMarket: null,
            derivativePathId: null,
        });
    });
    const vanLoans = vanLoanAcct.reduce((loans, acct) => {
        if (!accountName && acct.account_name) {
            accountName = acct.account_name;
        }
        // this is a commitment note
        if (acct.commitment_id) {
            loans.commitmentNotes.push({
                type: 'commitmentNote',
                accountNumber: acct.account_num,
                commitmentId: acct.commitment_id,
                noteId: acct.loan_id,
                productDescription: acct.product_desc,
                loanAmount: acct.current_loan_amount,
                noteDate: acct.loan_date,
                maturityDate: acct.maturity_date,
                interestRate: acct.interest_rate,
                currency: null,
                fxAmount: null,
                fxRate: null,
                currentBalance: acct.current_balance,
                source: 'IBS',
                contributesToPrincipalBalance: false,
                ultimateCommitmentId: _findUltimateCommitment({
                    commitmentId: acct.commitment_id,
                    commitments,
                }),
                valuationDate: null,
                usdCurrentNotionalAmount: null,
                initialMarginRequirementAmount: null,
                initialMarginRequirementRate: null,
                markToMarket: null,
                derivativePathId: null,
            });
            return loans;
        }
        // this is a standalone note
        principalBalance += acct.current_loan_amount;
        loans.standAloneNotes.push({
            type: 'standAloneNote',
            accountNumber: acct.account_num,
            commitmentId: null,
            noteId: acct.loan_id,
            productDescription: acct.product_desc,
            loanAmount: acct.current_loan_amount,
            noteDate: acct.loan_date,
            maturityDate: acct.maturity_date,
            interestRate: acct.interest_rate,
            currency: null,
            fxAmount: null,
            fxRate: null,
            currentBalance: acct.current_balance,
            source: 'IBS',
            contributesToPrincipalBalance: true,
            ultimateCommitmentId: null,
            valuationDate: null,
            usdCurrentNotionalAmount: null,
            initialMarginRequirementAmount: null,
            initialMarginRequirementRate: null,
            markToMarket: null,
            derivativePathId: null,
        });
        return loans;
    }, {
        standAloneNotes: [],
        commitmentNotes: [],
    });
    const cuoNotes = [];
    cuoLoan.forEach((loan) => {
        // this should never occur, hopefully
        (0, common_1.finleyAssert)(typeof loan.heloan_universal_num === 'string', 'cuoLoan.heloan_universal_num must exist to generate ValleyBankLoanAccount');
        cuoNotes.push({
            type: 'commitmentNote',
            accountNumber: loan.heloan_universal_num,
            commitmentId: loan.heloan_parent_acct_num,
            noteId: loan.heloan_acct_num,
            productDescription: loan.heloan_prod_type_desc,
            loanAmount: loan.heloan_current_credit_line_comm,
            noteDate: loan.heloan_note_dt,
            maturityDate: loan.heloan_mat_dt,
            interestRate: loan.heloan_int_rate,
            currency: loan.heloan_frgn_currency_code,
            fxAmount: loan.heloan_frgn_cur_amt,
            fxRate: loan.heloan_frgn_cur_xfr_rate,
            currentBalance: loan.heloan_collat_analysis_bal,
            source: loan.heloan_bsys_id,
            contributesToPrincipalBalance: false,
            ultimateCommitmentId: _findUltimateCommitment({
                commitmentId: loan.heloan_parent_acct_num,
                commitments,
            }),
            valuationDate: null,
            usdCurrentNotionalAmount: null,
            initialMarginRequirementAmount: null,
            initialMarginRequirementRate: null,
            markToMarket: null,
            derivativePathId: null,
        });
    });
    const derivPathLoans = [];
    derivativePath.forEach((dp) => {
        // if accountName is still null, name it Swap
        // placing this intentionally in the derivativePath loop,
        // such that there is at least one derivativePath in the loan account
        if (!accountName) {
            accountName = 'SWAP';
        }
        principalBalance += dp.exposure;
        derivPathLoans.push({
            type: 'derivativePath',
            accountNumber: dp.account_num,
            commitmentId: dp.account_num,
            noteId: null,
            derivativePathId: dp.id,
            productDescription: dp.product,
            loanAmount: dp.exposure,
            noteDate: null,
            maturityDate: dp.expiration_date,
            interestRate: null,
            currency: null,
            fxAmount: dp.notional_amount,
            fxRate: dp.fx_rate,
            currentBalance: dp.exposure,
            source: 'DerivativePath',
            contributesToPrincipalBalance: true,
            ultimateCommitmentId: null,
            valuationDate: dp.valuation_date,
            usdCurrentNotionalAmount: dp.usd_current_notional_amount,
            initialMarginRequirementAmount: dp.initial_margin_requirement_amount,
            initialMarginRequirementRate: dp.initial_margin_requirement_rate,
            markToMarket: dp.mark_to_market,
        });
    });
    return {
        loanAccountNumber,
        asOfDate,
        arrangementGroupId,
        reportingDate,
        cifNum,
        accountName,
        // valley bank has not indicated to Finley how to determine totalLoanAmount across all loans, for now, this has been hardcoded to zero
        totalLoanAmount: 0,
        principalBalance,
        standAloneNotes: vanLoans.standAloneNotes,
        commitmentNotes: [...vanLoans.commitmentNotes, ...cuoNotes],
        derivativePathLoans: derivPathLoans,
        commitments,
        loanParties,
    };
};
exports.generateLoanAccount = generateLoanAccount;
// ################################
// #
// # SUB LOAN ACCOUNTS STATS
// #
// ################################
const getValleyBankSubLoanAccountOutstandingBalance = (subLoan) => {
    // @jendevelops is it ok to just default to 0 if it's null?
    return subLoan.currentBalance ?? 0;
};
exports.getValleyBankSubLoanAccountOutstandingBalance = getValleyBankSubLoanAccountOutstandingBalance;
const isContributesToOutstandingBalance = (subLoan) => {
    return subLoan.contributesToPrincipalBalance;
};
exports.isContributesToOutstandingBalance = isContributesToOutstandingBalance;
const getSubLoansTotalOutstandingBalance = (subLoans) => {
    return subLoans.reduce((acc, subLoan) => {
        if ((0, exports.isContributesToOutstandingBalance)(subLoan)) {
            return acc + (0, exports.getValleyBankSubLoanAccountOutstandingBalance)(subLoan);
        }
        return acc;
    }, 0);
};
exports.getSubLoansTotalOutstandingBalance = getSubLoansTotalOutstandingBalance;
const isSubLoanAccountMasterCommitment = (loan) => {
    const { commitmentId, ultimateCommitmentId } = loan;
    if (!commitmentId || !ultimateCommitmentId)
        return false;
    return commitmentId === ultimateCommitmentId;
};
exports.isSubLoanAccountMasterCommitment = isSubLoanAccountMasterCommitment;
// ################################
// #
// # LOAN ACCOUNTS STATS
// #
// ################################
const _getValleyBankSubLoanAccountUniqueIdentifier = ({ type, commitmentId, accountNumber, noteId, }) => `${type}-${accountNumber}-${commitmentId}-${noteId}`;
exports._getValleyBankSubLoanAccountUniqueIdentifier = _getValleyBankSubLoanAccountUniqueIdentifier;
const _groupByUltimateCommitmentId = (loans) => {
    const commitmentsWithoutUltimateCommitment = [];
    const ultimateCommitmentToSubCommitmentsMap = {};
    loans.forEach((loan) => {
        if (!loan.ultimateCommitmentId) {
            commitmentsWithoutUltimateCommitment.push(loan);
        }
        else {
            if (!ultimateCommitmentToSubCommitmentsMap[loan.ultimateCommitmentId]) {
                ultimateCommitmentToSubCommitmentsMap[loan.ultimateCommitmentId] = [];
            }
            ultimateCommitmentToSubCommitmentsMap[loan.ultimateCommitmentId].push(loan);
        }
    });
    return {
        ultimateCommitmentToSubCommitmentsMap,
        commitmentsWithoutUltimateCommitment,
    };
};
const _groupByCommitmentId = (loans) => {
    const commitmentToCommitmentNoteMap = {};
    const commitmentNotesWithoutCommitmentId = [];
    loans.forEach((loan) => {
        const { commitmentId } = loan;
        if (!commitmentId) {
            commitmentNotesWithoutCommitmentId.push(loan);
        }
        else {
            if (!commitmentToCommitmentNoteMap[commitmentId]) {
                commitmentToCommitmentNoteMap[commitmentId] = [];
            }
            commitmentToCommitmentNoteMap[commitmentId].push(loan);
        }
    });
    return { commitmentToCommitmentNoteMap, commitmentNotesWithoutCommitmentId };
};
const getMasterLoanWithSubLoans = ({ masterCommitment, ultimateCommitmentToSubCommitmentsMap, commitmentToCommitmentNoteMap, }) => {
    if (!masterCommitment.commitmentId)
        return [];
    const commitmentWithNotes = [masterCommitment];
    // some commitmentNotes do not live under a "sub loan". and are directly related to a master commit
    const directCommitmentNotes = commitmentToCommitmentNoteMap[masterCommitment.commitmentId]?.sort() || [];
    directCommitmentNotes.forEach((note) => {
        commitmentWithNotes.push(note);
    });
    const subLoans = ultimateCommitmentToSubCommitmentsMap[masterCommitment.commitmentId] || [];
    const subLoansAndCommitmentNotes = subLoans.flatMap((subLoan) => {
        let output = [subLoan];
        if (!subLoan.commitmentId)
            return output;
        const commitmentNotes = commitmentToCommitmentNoteMap[subLoan.commitmentId] || [];
        output = output.concat(commitmentNotes);
        return output;
    });
    return _.concat(commitmentWithNotes, subLoansAndCommitmentNotes);
};
const findCommitmentsWithMissingParentCommit = ({ allCommitments, groupedCommitments, }) => {
    // superset has to be first argument, otherwise it doesn't work
    // ask me how I know
    const missingParentCommitments = _.differenceBy(allCommitments, groupedCommitments, exports._getValleyBankSubLoanAccountUniqueIdentifier);
    return missingParentCommitments;
};
exports.findCommitmentsWithMissingParentCommit = findCommitmentsWithMissingParentCommit;
/**
 * vanCmmt has master + sub commitments
 * vanLoanAcct has
 *  - standalone notes (unlrelated to any commitment)
 *  - commitmentNotes (related to a commitment)
 * cuoLoan has commitmentNotes related to a commitment
 *
 * Maureen wants the following order
 *
 * 1. Master Commitments with outstanding balance
 *   - with sub commitment
 *   - related commitment notes that share the same commitmentId
 * 2. Standalone notes with outstanding balance
 * 3. Master Commitments without outstanding balance
 *  - with sub commitment
 *  - related commitment notes that share the same commitmentId
 * 4. Standalone notes without outstanding balance
 */
const orderLoanAccountLoans = (loanAccount) => {
    const { commitments, standAloneNotes, commitmentNotes } = loanAccount;
    // first want to see master commitments + their sub commitments
    const [masterCommitments, subCommitments] = _.partition(commitments, exports.isSubLoanAccountMasterCommitment);
    // subCommitments related to masterCommitments through ultimateCommitmentId
    const { ultimateCommitmentToSubCommitmentsMap, commitmentsWithoutUltimateCommitment, } = _groupByUltimateCommitmentId(subCommitments);
    // commitmentNotes related to subCommitments (from commitments array)
    const { commitmentToCommitmentNoteMap, commitmentNotesWithoutCommitmentId, } = _groupByCommitmentId(commitmentNotes);
    const [masterCommitmentsWithOutstandingBalance, masterCommitmentsWithoutOutstandingBalance,] = _.partition(masterCommitments, (mstCmmt) => {
        return (0, exports.getValleyBankSubLoanAccountOutstandingBalance)(mstCmmt) > 0;
    });
    const masterCommitmentsWithOutstandingBalanceAndSubLoans = masterCommitmentsWithOutstandingBalance.flatMap((masterCommitment) => getMasterLoanWithSubLoans({
        masterCommitment,
        ultimateCommitmentToSubCommitmentsMap,
        commitmentToCommitmentNoteMap,
    }));
    const masterCommitmentsWithoutOutstandingBalanceAndSubLoans = masterCommitmentsWithoutOutstandingBalance.flatMap((masterCommitment) => getMasterLoanWithSubLoans({
        masterCommitment,
        ultimateCommitmentToSubCommitmentsMap,
        commitmentToCommitmentNoteMap,
    }));
    const allCommitments = _.concat(commitments, commitmentNotes);
    /**
     * Edge case
     * if a subCommitment or commitmentNote does't have a corresponding masterCommitment record in commitments
     * they won't show up unless we aggregate them to append to the end of the ordered list
     */
    const missingParentCommitments = (0, exports.findCommitmentsWithMissingParentCommit)({
        allCommitments,
        groupedCommitments: _.concat(masterCommitmentsWithOutstandingBalanceAndSubLoans, masterCommitmentsWithoutOutstandingBalanceAndSubLoans),
    });
    const [standAloneNotesWithOutstandingBalance, standAloneNotesWithoutOutstandingBalance,] = _.partition(standAloneNotes, (note) => {
        return (0, exports.getValleyBankSubLoanAccountOutstandingBalance)(note) > 0;
    });
    return {
        masterCommitmentsWithOutstandingBalanceAndSubLoans,
        standAloneNotesWithOutstandingBalance,
        masterCommitmentsWithoutOutstandingBalanceAndSubLoans,
        commitmentsWithoutUltimateCommitment,
        commitmentNotesWithoutCommitmentId,
        standAloneNotesWithoutOutstandingBalance,
        missingParentCommitments,
    };
};
const orderLoanAccountsLoans = (loanAccounts) => {
    const output = {
        masterCommitmentsWithOutstandingBalanceAndSubLoans: [],
        standAloneNotesWithOutstandingBalance: [],
        masterCommitmentsWithoutOutstandingBalanceAndSubLoans: [],
        commitmentsWithoutUltimateCommitment: [],
        commitmentNotesWithoutCommitmentId: [],
        standAloneNotesWithoutOutstandingBalance: [],
        missingParentCommitments: [],
    };
    const keys = Object.keys(output);
    // @vb-deriv - orderLoanAccountLoans ignores derivPath for now,
    // and just concats that at the end of all loans. review this later,
    // but functionally correct for now.
    const orderedLoanAccounts = loanAccounts.map(orderLoanAccountLoans);
    orderedLoanAccounts.reduce((acc, orderLoans) => {
        keys.forEach((key) => {
            // eslint-disable-next-line no-param-reassign
            acc[key] = acc[key].concat(orderLoans[key]);
        });
        return acc;
    }, output);
    return [
        output.masterCommitmentsWithOutstandingBalanceAndSubLoans,
        output.standAloneNotesWithOutstandingBalance,
        output.masterCommitmentsWithoutOutstandingBalanceAndSubLoans,
        output.commitmentsWithoutUltimateCommitment,
        output.commitmentNotesWithoutCommitmentId,
        output.standAloneNotesWithoutOutstandingBalance,
        output.missingParentCommitments,
        loanAccounts.flatMap((la) => la.derivativePathLoans), // flatten derivative path at end
    ].flat();
};
exports.orderLoanAccountsLoans = orderLoanAccountsLoans;
const getLoans = (loanAccount) => {
    return [
        loanAccount.standAloneNotes,
        loanAccount.commitmentNotes,
        loanAccount.commitments,
        loanAccount.derivativePathLoans,
    ].flat();
};
exports.getLoans = getLoans;
const getTotalLoanOutstanding = (loanAccounts) => {
    return loanAccounts.reduce((acc, la) => acc + la.principalBalance, 0);
};
exports.getTotalLoanOutstanding = getTotalLoanOutstanding;
const getMarginStatusCount = (loanAccounts) => {
    const marginStatusCount = {
        underMargin: 0,
        nearMargin: 0,
        excessMargin: 0,
    };
    loanAccounts.forEach(({ principalBalance, totalPostAllocationLendableValue, marginAvailabilityRate, }) => {
        const status = (0, utils_1.getMarginAvailabilityStatus)({
            loanOutstanding: principalBalance,
            collateralLendableValue: totalPostAllocationLendableValue,
            marginAvailabilityRate,
        });
        marginStatusCount[status] += 1;
    });
    return marginStatusCount;
};
const getLoanAccountCollateralStats = ({ loanAccount, }) => {
    const assignedReceivables = loanAccount.collateralAccounts.flatMap(({ receivables }) => receivables);
    const stats = (0, generateReceivableStats_1.generateReceivableStats)(assignedReceivables);
    // Total Market Value
    // Effective Advance rate
    // Pre Allocation Lendable Value
    // Effective Allocation    (not on customer)
    // Post Allocation Lendable Value (not on customer)
    const marginAvailable = stats.totalPostAllocationLendableValue - loanAccount.principalBalance;
    const marginAvailabilityRate = (0, utils_1.calculateMarginAvailabilityRate)({
        loanOutstanding: loanAccount.principalBalance,
        collateralLendableValue: stats.totalPostAllocationLendableValue,
    });
    return {
        // stat from all receivables of collateral account
        totalMarketValue: stats.totalMarketValue,
        // @jendevelops DELETE ME
        effectiveAllocationRate: stats.effectiveAllocationRate,
        // stat from all receivables of collateral account
        effectiveAdvanceRate: stats.effectiveAdvanceRate,
        // "assignedLendableValue" stat from receivables pledged to loan account
        totalLendableValue: stats.totalPreAllocationLendableValue,
        totalPostAllocationLendableValue: stats.totalPostAllocationLendableValue,
        marginAvailable,
        marginAvailabilityRate,
    };
};
exports.getLoanAccountCollateralStats = getLoanAccountCollateralStats;
const getLoanAccountStats = (loanAccounts) => {
    const { underMargin: underMarginStatusCount, nearMargin: nearMarginStatusCount, excessMargin: excessMarginStatusCount, } = getMarginStatusCount(loanAccounts);
    // all lendable value on a loan account is assigned to a loan, so it's assignedLendableValue
    const assignedLendableValue = loanAccounts.reduce((acc, loanAccount) => acc + loanAccount.totalLendableValue, 0);
    const totalOutstandingBalance = (0, exports.getTotalLoanOutstanding)(loanAccounts);
    const totalMarginAvailability = assignedLendableValue - totalOutstandingBalance;
    const totalMarginAvailabilityRate = (0, utils_1.calculateMarginAvailabilityRate)({
        loanOutstanding: totalOutstandingBalance,
        collateralLendableValue: assignedLendableValue,
    });
    return {
        totalOutstandingBalance,
        totalMarginAvailability,
        totalMarginAvailabilityRate,
        loanAccountsCount: loanAccounts.length,
        underMarginStatusCount,
        nearMarginStatusCount,
        excessMarginStatusCount,
    };
};
exports.getLoanAccountStats = getLoanAccountStats;
const generateValleyBankLoanAccountWithCollateralStats = ({ loanAccount, receivables, collateralAccountCustomers, }) => {
    // these collateral accounts have top level stats from their whole portfolio
    // but only return receivables assigned to the loanAccount
    const collateralAccounts = collateralAccountUtils.generateCollateralAccountsForLoanAccount({
        receivables,
        loanAccountNumber: loanAccount.loanAccountNumber,
        collateralAccountCustomers,
    });
    return {
        ...loanAccount,
        ...(0, exports.getLoanAccountCollateralStats)({
            loanAccount: { ...loanAccount, collateralAccounts },
        }),
    };
};
exports.generateValleyBankLoanAccountWithCollateralStats = generateValleyBankLoanAccountWithCollateralStats;
//# sourceMappingURL=loanAccount.js.map